import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class TicketResource extends AuthenticatedResource {
  static urlRoot = '/tickets' as const

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }

}